export const settings = window.dockyard?.settings;

export const isAvailableRebrandingForCIS = () => {
    return settings.isCISRegion && settings.realm === 'ru';
};
